import { render, staticRenderFns } from "./ManageAccount.vue?vue&type=template&id=b2c5d480&scoped=true"
import script from "./ManageAccount.vue?vue&type=script&lang=js"
export * from "./ManageAccount.vue?vue&type=script&lang=js"
import style0 from "./ManageAccount.vue?vue&type=style&index=0&id=b2c5d480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c5d480",
  null
  
)

export default component.exports